// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import TravelHelpController from "./travel_help_controller"
application.register("travel-help", TravelHelpController)

import AdminDrawerController from "./admin_drawer_controller"
application.register("admin-drawer", AdminDrawerController)

import AdminReviewController from "./admin_review_controller"
application.register("admin-review", AdminReviewController)

import BadgeShowcaseController from "./badge_showcase_controller"
application.register("badge-showcase", BadgeShowcaseController)

import AdminPreviewController from "./admin_preview_controller"
application.register("admin-preview", AdminPreviewController)

import ChatRoomController from "./chat_room_controller"
application.register("chat-room", ChatRoomController)

import FileUploadController from "./file_upload_controller"
application.register("file-upload", FileUploadController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import MbwayPaymentController from "./mbway_payment_controller"
application.register("mbway-payment", MbwayPaymentController)

import NarrationController from "./narration_controller"
application.register("narration", NarrationController)

import NewChatController from "./new_chat_controller"
application.register("new-chat", NewChatController)

import PeopleFilterController from "./people_filter_controller"
application.register("people-filter", PeopleFilterController)

import NotificationCenterController from "./notification_center_controller"
application.register("notification-center", NotificationCenterController)

import NotificationToastController from "./notification_toast_controller"
application.register("notification-toast", NotificationToastController)

import PwaRegistrationController from "./pwa_registration_controller"
application.register("pwa-registration", PwaRegistrationController)

import ScreenLockController from "./screen_lock_controller"
application.register("screen-lock", ScreenLockController)
